<template>

  <el-container>
    <embed id="NPCom" type="application/x-yibao-plugin" width=0 height=0>
    <OBJECT id="NLHostcomm" classid="clsid:CC872CC4-13DD-4E17-8A85-67FD420767E4" width=0 height=0
            codebase="yibaoATL.cab#version=1,0,0,0"></OBJECT>

    <div class="d">
      <div id="result" style="color:#F00; font-size: 12px;">在此处显示每次执行过程中返回的错误信息</div>
      <div class="order_title">订单基本信息</div>
      <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" class="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号:">
              <el-input v-model="formData.orderNo" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单总额:">
              <el-input v-model="formData.amount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名:">
              <el-input v-model="formData.userName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付状态:">
              <el-input v-model="formData.status" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付方式:">
              <el-input v-model="formData.type" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提示信息:" style="color: red">
              点击“刷卡”按钮进行POS刷卡
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="">
              <el-button @click="confirmPay()" type="primary" size="small">刷卡</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-container>
</template>

<script>
  import https from '@/https.js';

  export default {
    name: "posPay",
    data() {
      return {
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        formData: {
          orderId: '',
          orderNo: '',
          amount: '',
          userName: '',
          status: '待支付',
          type: '在线支付'
        },
        obj: {},
        initPos: '',
      };
    },
    methods: {
      confirmPay() {
        let obj = document.getElementById('NLHostcomm');
        if (typeof(obj.Req) == 'undefined') {
          obj = document.getElementById('NPCom');
          if (typeof(obj.Req) == 'undefined') {
            alert('该浏览器不支持插件，建议使用IE或360浏览器！');
            return;
          }
        }
        let initPos = this.initPos;
        try {
          obj.Req = initPos;
          console.log(initPos);
          let errMsg = obj.POSPChang();
          let bufr = obj.GetResponData();
          this.sendOrder(bufr)
        } catch (e) {
          console.log(e);
          this.$message.error('请求失败');
        }
        document.getElementById('result').innerHTML = "成功";
      },
      sendOrder(bufr) {
        let params = {
          data: bufr
        }
        https.fetchPost('/payment/posPayReturn', params).then((data) => {
          let code = data.data.code;
          let msg  = data.data.msg;
          if (code == 200) {
            if("success" == msg) {
              this.$message({
                type: 'success',
                message: '刷卡成功'
              });
            }
          } else {
            this.$message({
              type: 'info',
              message: '请求失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );

      },
      getReq() {
        let params = {
          orderId: this.formData.orderId
        };
        https.fetchPost('/payment/posPay', params).then((data) => {
          let code = data.data.code;
          let msg  = data.data.msg;
          if (code == 200) {
            let str = data.data.data;
            this.initPos = str;
          } else {
            this.$message({
              type: 'info',
              message: '请求失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              this.loading = false;
            }
        );
      },
      install() {
        var bInstall = true;
        var name = navigator.appName;
        if (name == 'Netscape') {
          var plugin = navigator.plugins['npyibao plugin'];
          if (plugin) {
            bInstall = false;
          }
        } else if (name == 'Microsoft Internet Explorer') {
          try {
            var ax = new ActiveXObject('FirstCOM.math.1');
            bInstall = false;
          } catch (e) {
          }
        } else {
          bInstall = false;
          alert('浏览器内核不支持该插件！');
        }

      }
    },
    created: function() {
      let form = this.$route.params;
      if (form.orderId) {
        this.formData.orderId = form.orderId;
        this.formData.orderNo = form.orderNo;
        this.formData.amount = form.amount;
        this.formData.status = '待支付';
        this.formData.type = '在线支付';
        this.formData.userName = form.userName;
      }else {
        this.$router.push({
          name: "order"
        })
        return
      }
      this.install();
      this.getReq();
    }
  };
</script>

<style scoped>

  .d {
    width: 60%;
    margin: 20px 0 0 50px;
    border-radius: 10px;
    border: 1px solid #DCDFE6;
    padding-bottom: 40px;
  }

  .order_title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    background: #f0f0f0;
    margin-bottom: 20px;
    padding-left: 40px;
  }

  .form {
    border: 1px solid #DCDFE6;
    border-radius: 10px;
    padding-top: 15px;
    background: #f0f0f0;
    margin: 0 40px;
  }

</style>
